// Chargeur reCAPTCHA v3 partagé : charge le script une seule fois et renvoie un token.
const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
let loading = null;

function loadScript() {
  if (!SITE_KEY) return Promise.resolve(null);
  if (window.grecaptcha) return Promise.resolve(window.grecaptcha);
  if (loading) return loading;
  loading = new Promise((resolve) => {
    const existing = document.getElementById("recaptcha-v3");
    if (existing) {
      const iv = setInterval(() => { if (window.grecaptcha) { clearInterval(iv); resolve(window.grecaptcha); } }, 100);
      return;
    }
    const s = document.createElement("script");
    s.id = "recaptcha-v3";
    s.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    s.onload = () => resolve(window.grecaptcha);
    s.onerror = () => resolve(null);
    document.head.appendChild(s);
  });
  return loading;
}

export async function getRecaptchaToken(action = "submit") {
  if (!SITE_KEY) return null;
  const g = await loadScript();
  if (!g) return null;
  return new Promise((resolve) => {
    g.ready(() => g.execute(SITE_KEY, { action }).then(resolve).catch(() => resolve(null)));
  });
}
